module.exports = __webpack_public_path__ + "img/icon_t.41a2ad74.png";